export default __webpack_public_path__ + "static/media/Skirmisher's Bolts.e553a1d6.jpg";